module.exports = __webpack_public_path__ + "img/aliexpressChoice.4b92f66c.png";